export default __webpack_public_path__ + "d9b50c90835ee2d9822c818e39b3a354.ttf";